// src/AllahNames.js
import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography, Grid } from '@mui/material';

const AllahNames = () => {
  const [names, setNames] = useState([]);

  useEffect(() => {
    const fetchNames = async () => {
      try {
        const response = await fetch('https://api.aladhan.com/v1/asmaAlHusna');
        const data = await response.json();
        setNames(data.data);
      } catch (error) {
        console.error('Error fetching names:', error);
      }
    };

    fetchNames();
  }, []);

  return (
    <Grid style={{ marginTop: '10px' }} container spacing={2}>
      <Typography sx={{
        color: 'gold', fontWeight: 'lighter', fontSize: 'small'
        , textAlign: 'center', fontStyle: 'italic',position:'relative',
        transform:'translate(-50%,0)',left:'50%',marginTop:'10px',marginLeft:'10px',marginRight:'10px'
      }}>
        He is  Allah, the Creator, the Inventor of all things, To Him belong the Best Names. All that is in the heavens and the earth glorify Him. And He is the All-Mighty, the All-Wise.  <strong style={{color:'whitesmoke'}}> (Surat Al-Hashr 59:24)</strong>
        <br /><br />
      <strong style={{color:'whitesmoke'}}>  Although in Islamic traditions, there are 99 names attributed to him, Allah is the proper, all-comprehensive name. Allah does not exist in one single place and is dimensionless, omnipotent, and omnipresent.</strong>
        <br /><br />
        Narrated Abu Huraira: Hazrat Muhammad (ﷺ) Said; “Allah has ninety-nine names, and whoever knows them, will go to Paradise.”  <strong style={{color:'whitesmoke'}}>  (Sahih Al-Bukhari 50:894)</strong>
      </Typography>
      <br /><br />
      {names.map((name) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={name.number}>
          <Card style={{ backgroundColor: 'darkslategray', marginLeft: '5px', marginRight: '5px', height: '180px' }}>
            <CardContent >
              <Typography variant="h4" sx={{ color: 'gold' }} component="div">
                {name.name}
              </Typography>
              <Typography variant="h6" sx={{ color: 'goldenrod', fontFamily: 'Cinzel Decorative' }} gutterBottom>
                {name.transliteration}
              </Typography>
              <Typography color="text.secondary" style={{ color: 'whitesmoke', fontFamily: 'OpenSans' }}><strong style={{ color: 'gold' }}> Number: </strong>{name.number}</Typography>
              <Typography color="text.secondary" sx={{ color: 'whitesmoke', fontFamily: 'OpenSans' }}><strong style={{ color: 'gold' }}> Meaning:</strong> {name.en.meaning}</Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default AllahNames;
